<template>
    <div>
      <v-select
        ref="selectField"
        v-bind:placeholder="placeholder"
        v-bind:class="{'is-invalid': hasError(), 'searchable-select': true, 'searchable-auto-width': dropdownAutoWidth}"
        :value="selectedValue"
        :map-keydown="mapKeyHandlers"
        v-on:input="onInputUpdated($event)"
        v-on:search="onSearch"
        v-if="!loading && !loadingError"
        :options="options"
        :filterBy="filterBy"
        :filterable="filterable"
        :clearable="clearable"
        :appendToBody="appendToBody"
        label="name">
        <template #option="option" v-if="optionSlot">
          <slot name="option" :data="option" />
        </template>
        <template #selected-option="option">
          {{option[selectedDisplayKey]}}
        </template>
      </v-select>
      <Spinner v-if="loading" />
      <div class="form-invalid-feedback" v-if="hasError()">
        {{getError()}}
      </div>
      <span v-if="!hasError() && note" class="form-field-note">{{note}}</span>
      <span class="text-danger" v-if="loadingError">{{loadingError}}</span>
    </div>
</template>

<style lang="scss">
.searchable-select .vs__search::placeholder,
.searchable-select .vs__dropdown-toggle,
.searchable-select .vs__dropdown-menu {
    background-color: #FFFFFF;
    background-image: none;
    border: 1px solid #e5e6e7;
    border-radius: $control-border-radius;
    padding: 3px 6px 6px 2px;
}
.searchable-select .vs__search::placeholder {
  color: #c9cbcc;
}
.searchable-select.searchable-auto-width .vs__dropdown-menu {
  width: auto;
}
.vs__dropdown-menu {
 z-index: 99999999;
}

.theme-dark .searchable-select .vs__search::placeholder,
.theme-dark .searchable-select .vs__dropdown-toggle,
.theme-dark .searchable-select .vs__dropdown-menu {
  background-color: #333333;
  border: 1px solid #404040;
}
.theme-dark .searchable-select .vs__dropdown-option {
  color: #efefef;
}
.theme-dark .searchable-select .vs__search::placeholder {
  color: #676767;
}
.theme-dark .searchable-select input {
  color: #efefef;
}
.theme-dark .searchable-select .vs__selected {
  color: #efefef;
}
.theme-dark .searchable-select .vs__actions .vs__clear {
  color: #efefef;
  fill: rgba(255,255,255,0.5);
}
.theme-dark .searchable-select .vs__actions .vs__open-indicator {
  color: #efefef;
  fill: rgba(255,255,255,0.5);
}
</style>

<script>
import formField from '@/mixins/formField'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';

export default {
  name: "FormSearchableSelect",
  mixins: [formField],
  components: {
    'v-select': vSelect
  },
  props: {
    value: [String, Number],
    options: Array,
    placeholder: String,
    field: String,
    loading: {
      type: Boolean,
      default: false
    },
    loadingError: String,
    note: String,
    selectOnTab: {
      type: Boolean,
      default: true
    },
    selectedDisplayKey: {
      type: String,
      default: 'name'
    },
    clearable: {
      type: Boolean,
      default: true
    },
    filterable: {
      type: Boolean,
      default: true
    },
    filterBy: {
      type: Function,
      default(option, label, search) {
        return (label || '').toLowerCase().indexOf(search.toLowerCase()) > -1
      }
    },
    dropdownAutoWidth: {
      type: Boolean,
      default: false
    },
    optionSlot: {
      type: Boolean,
      default: false
    },
    appendToBody: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value: function(newVal, oldVal) {
      this.updateSelectedValue()
    },
    options: function(newVal, oldVal) {
      this.updateSelectedValue()
    }
  },
  data() {
    return {
      selectedValue: null
    }
  },
  mounted() {
    // Required if the value is set before the component is mounted
    // Happens when populating entry lists via code
    this.updateSelectedValue()
  },
  computed: {
  },
  methods: {
    hasError() {
      return this.getFieldError(this.$props.field).length > 0
    },
    getError() {
      return this.getFieldError(this.$props.field)
    },
    onInputUpdated(event) {
      if(event == null) {
        this.$emit('input', null)
        return
      }

      this.$emit('input', event.value)
    },
    onSearch(search, loading) {
      this.$emit('search', search, loading)
    },
    updateSelectedValue() {
      if(this.$props.options == null)
        return

      var item = this.$props.options.find(item => item.value == this.$props.value)
      if(item === undefined)
        this.$data.selectedValue = null
      else
        this.$data.selectedValue = item

      // Reset error when typing if the field was blank
      // Not 100% fix to clearing errors (eg, some errors may be logic based) but helpful
      this.resetFieldError(this.$props.field)
    },
    focus() {
      this.$refs.selectField.$refs.search.focus()
    },
    select() {
      this.$refs.selectField.$refs.search.select()
    },
    mapKeyHandlers: function(map, vm) {
      return {
        ...map, 9: e => {
          if(this.selectOnTab) {
            e.preventDefault()
            return vm.typeAheadSelect()
          } else {
            return vm.onTab()
          }
        },
      }
    }
  }
};
</script>